module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-bottom-segment-visualisation-middle.3be7d832.png";